// extracted by mini-css-extract-plugin
export default {"YoutubeEmbed":"bbm_a"};